import React, { createContext, useContext, useState } from "react";

type TabsContextType = {
  activeTab: string;
  setActiveTab: (key: string) => void;
  userDetailsModal: boolean;
  setUserDetailsModal: (key: boolean) => void;
  sessionReportModal: boolean;
  setAmberModal: (key: boolean) => void;
  amberModal: boolean;
  setSessionReportModal: (key: boolean) => void;
  goalsInTheraphyModal: boolean;
  setGoalsInTheraphyModal: (key: boolean) => void;
  setSelectedModalObj: (obj: any | null) => void;
  selectedModalObj: any | null;
  setSelectedModalObjNotes: (obj: any | null) => void;
  selectedModalObjNotes: any | null;
  SessionNotesModal: boolean;
  setSessionNotesModal: (key: boolean) => void;
  counselorTakeAwayModal: boolean;
  setCounselorTakeAwayModal: (key: boolean) => void;
  seniorcounselorTakeAwayModal: boolean;
  setSeniorcounselorTakeAwayModal: (key: boolean) => void;
  setSelectedModalObjReport: (obj: any | null) => void;
  selectedModalObjReport: any | null;
  setSelectedModalObjGoals: (obj: any | null) => void;
  selectedModalObjCounselor: any | null;
  setSelectedModalObjCounselor: (obj: any | null) => void;
  selectedModalObjGoals: any | null;
  setTakeAwayObj: (obj: any | null) => void;
  TakeAwayObj: any | null;
  setRedflagModal: (key: boolean) => void;
  redflagModal: boolean;
  setUserDetails: (obj: any | null) => void;
  userDetails: any | null;
  setRedFlagChecked: (obj: any | null) => void;
  redFlagChecked: any | null;
  setSeniocounselorObj: (obj: any | null) => void;
  seniorCounselorObj: any | null;
  SetamberChecked: (obj: any | null) => void;
  amberChecked: any | null;
  setAmberModalAlt: (key: boolean) => void;
  amberModalalt: boolean;
  setSelectedModalObjamber: (obj: any | null) => void;
  selectedModalObjamber: any | null;
};

const UserFilesTabsContext = createContext<TabsContextType | undefined>(
  undefined,
);
export const UserFilesTabsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [activeTab, setActiveTab] = useState<string>("session_report");
  const [userDetailsModal, setUserDetailsModal] = useState<boolean>(false);
  const [amberModal, setAmberModal] = useState<boolean>(false);
  const [sessionReportModal, setSessionReportModal] = useState<boolean>(false);
  const [goalsInTheraphyModal, setGoalsInTheraphyModal] =
    useState<boolean>(false);
  const [selectedModalObj, setSelectedModalObj] = useState<any | null>(null);
  const [SessionNotesModal, setSessionNotesModal] = useState<boolean>(false);
  const [counselorTakeAwayModal, setCounselorTakeAwayModal] =
    useState<boolean>(false);
  const [selectedModalObjNotes, setSelectedModalObjNotes] = useState<
    any | null
  >(null);
  const [seniorcounselorTakeAwayModal, setSeniorcounselorTakeAwayModal] =
    useState<boolean>(false);
  const [selectedModalObjReport, setSelectedModalObjReport] = useState<
    any | null
  >(null);
  const [selectedModalObjGoals, setSelectedModalObjGoals] = useState<
    any | null
  >(null);
  
  const [selectedModalObjamber, setSelectedModalObjamber] = useState<
    any | null
  >(null);
  const [selectedModalObjCounselor, setSelectedModalObjCounselor] = useState<
    any | null
  >(null);
  const [redflagModal, setRedflagModal] = useState<boolean>(false);
  const [amberModalalt, setAmberModalAlt] = useState<boolean>(false);
  const [userDetails, setUserDetails] = useState<any | null>(null);
  const [redFlagChecked, setRedFlagChecked] = useState<any | null>(null);
  const [amberChecked, SetamberChecked] = useState<any | null>(null);
  const [seniorCounselorObj, setSeniocounselorObj] = useState<any | null>(null);
    const [TakeAwayObj, setTakeAwayObj] = useState<any | null>(null);


  return (
    <UserFilesTabsContext.Provider
      value={{
        setTakeAwayObj,
        TakeAwayObj,
        activeTab,
        setActiveTab,
        userDetailsModal,
        setUserDetailsModal,
        sessionReportModal,
        setSessionReportModal,
        goalsInTheraphyModal,
        setGoalsInTheraphyModal,
        setSelectedModalObj,
        selectedModalObj,
        setSessionNotesModal,
        SessionNotesModal,
        setCounselorTakeAwayModal,
        counselorTakeAwayModal,
        setSelectedModalObjNotes,
        selectedModalObjNotes,
        seniorcounselorTakeAwayModal,
        setSeniorcounselorTakeAwayModal,
        setSelectedModalObjReport,
        selectedModalObjReport,
        setSelectedModalObjGoals,
        selectedModalObjGoals,
        setSelectedModalObjCounselor,
        selectedModalObjCounselor,
        redflagModal,
        setRedflagModal,
        setUserDetails,
        userDetails,
        redFlagChecked,
        setRedFlagChecked,
        setSeniocounselorObj,
        seniorCounselorObj,
        setAmberModal,
        amberModal,
        SetamberChecked,
        amberChecked,
        setAmberModalAlt,
        amberModalalt,
        selectedModalObjamber,
        setSelectedModalObjamber
      }}
    >
      {children}
    </UserFilesTabsContext.Provider>
  );
};

export const useUserFilesTabs = () => {
  const context = useContext(UserFilesTabsContext);
  if (!context) {
    throw new Error(
      "useUserFilesTabs must be used within UserFilesTabsProvider",
    );
  }
  return context;
};
